import { render, staticRenderFns } from "./Prescriptions-insurance.vue?vue&type=template&id=2b356681&scoped=true&"
import script from "./Prescriptions-insurance.vue?vue&type=script&lang=js&"
export * from "./Prescriptions-insurance.vue?vue&type=script&lang=js&"
import style0 from "./Prescriptions-insurance.vue?vue&type=style&index=0&id=2b356681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b356681",
  null
  
)

export default component.exports